import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { motion } from "framer-motion";
import { treatmentsGandhidham} from "../Data";
import ErrorPage from './ErrorPage'
import MedicalWebPageSchema from "../Schema/MedicalWebPageSchema";
import MedicalTherapySchema from "../Schema/MedicalTherapySchema";
import BreadcrumbSchema from "../Schema/BreadcrumbSchema";
import MedicalClinicSchema from "../Schema/MedicalClinicSchema";
import Breadcrumb from "../Components/Breadcrumb";
import TreatmentsIntro from "../Components/TreatmentsIntro";
import AyurvedicApproach from "../Components/AyurvedicApproach";
import TreatmentCareGrid from "../Components/TreatmentCareGrid";
import WhyChoose from "../Components/WhyChoose";
import Stats from "../Components/Stats";
import TreatmentGrid from "../Components/TreatmentGrid";
import Testimonials from "../Components/Testimonials";
import Cta from "../Components/Cta";

const containerVariant = {
  hidden: {},
  visible: {
    transition: {
      staggerChildren: 0.15,
    },
  },
};

const fadeUp = {
  hidden: {
    opacity: 0,
    y: 30,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.8,
      ease: "easeOut",
    },
  },
};

const cardVariant = {
  hidden: {
    opacity: 0,
    y: 40,
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.7,
      ease: "easeOut",
    },
  },
};

const pointVariant = {
  hidden: {
    opacity: 0,
    x: -15,
  },
  visible: {
    opacity: 1,
    x: 0,
    transition: {
      duration: 0.45,
    },
  },
};

const TreatmentsDetailGandhidham=()=>{

 const { slug } = useParams();
 const treatment = treatmentsGandhidham.find(item => item.slug === slug);

  useEffect(() => {
      if (!treatment) return;
      document.title = `${treatment.metaTitle}`;

      const metaDesc = document.querySelector(
        "meta[name='description']"
      );
      if (metaDesc) {
        metaDesc.setAttribute("content", treatment.metaDesc);
      }

        let canonical = document.querySelector("link[rel='canonical']");
  if (!canonical) {
    canonical = document.createElement("link");
    canonical.setAttribute("rel", "canonical");
    document.head.appendChild(canonical);
  }

  canonical.setAttribute(
    "href",
    `https://msayurved.com/treatments/gandhidham/${slug}`
  );

   const ogTitle = document.querySelector("meta[property='og:title']");
  if (ogTitle) {
    ogTitle.setAttribute(
      "content",
      treatment.metaTitle
    );
  }

    const ogDesc = document.querySelector("meta[property='og:description']");
  if (ogDesc) {
    ogDesc.setAttribute(
      "content",
      treatment.metaDesc
    );
  }

 const ogUrl = document.querySelector("meta[property='og:url']");
  if (ogUrl) {
    ogUrl.setAttribute("content",  `https://msayurved.com/treatments/gandhidham/${slug}`);
  }

    const ogImage = document.querySelector("meta[property='og:image']");
  if (ogImage) {
    ogImage.setAttribute(
      "content",
      treatment.canonicalImg
    );
  }

    const twitterTitle = document.querySelector("meta[name='twitter:title']");
  if (twitterTitle) {
    twitterTitle.setAttribute(
      "content",
     treatment.metaTitle
    );
  }

    const twitterDesc = document.querySelector(
    "meta[name='twitter:description']"
  );
  if (twitterDesc) {
    twitterDesc.setAttribute(
      "content",
   treatment.metaDesc
    );
  }

    const twitterImage = document.querySelector("meta[name='twitter:image']");
  if (twitterImage) {
    twitterImage.setAttribute(
      "content",
      treatment.canonicalImg
    );
  }

    }, [treatment, slug]);


  if (!treatment) {
    return <ErrorPage />;
  }

const breadcrumbItems = [
    {
      name: "Home",
      url: "https://msayurved.com/"
    },
    {
      name: "Treatments in Gandhidham",
      url: "https://msayurved.com/treatments/gandhidham"
    },
    {
      name: treatment.breadcrumbTitle,
      url: `https://msayurved.com/treatments/gandhidham/${treatment.slug}`
    }
  ];

    return(
        <>
         <React.Fragment key={slug}>

        <MedicalWebPageSchema treatment={treatment} />
        <MedicalTherapySchema treatment={treatment} />
        <BreadcrumbSchema items={breadcrumbItems} />
        <MedicalClinicSchema />

        {/**BREADCRUMB SECTION */}
        <Breadcrumb
        title={treatment.breadcrumbTitle}
        bgImage={treatment.bgImg}
        />

        {/**INTRODUCTION SECTION */}
        <TreatmentsIntro
          img={treatment.introImg}
          title={treatment.introHeading}
          description={treatment.introDesc}
          subheading={treatment.introSubHeading}
          item={treatment.introPoints}
        />

        {/**FACTORS + AYURVEDIC APPROACH SECTION */}
       {treatment.showSpecialSection ? (
        <motion.section
         className="treatment-special-section container"
         variants={containerVariant}
         initial="hidden"
         whileInView="visible"
         viewport={{
          once: true,
          amount: 0.15,
        }}
        >
      <motion.h2
       className="section-heading treatment-special-heading"
       variants={fadeUp}
      >
     {treatment.specialHeading}
     </motion.h2>
     <motion.div
      className="treatment-special-grid"
      variants={containerVariant}
     >
      {treatment.specialCards.map((item, index) => (
       <motion.div
        className="treatment-special-card"
        key={index}
        variants={cardVariant}
        whileHover={{
          y: -5,
        }}
        transition={{
          duration: 0.4,
        }}
      >
      <motion.h3
        className="card-heading"
        variants={fadeUp}
      >
      {item.mainHeading}
      </motion.h3>
      <motion.div
        variants={containerVariant}
        >
        {item.points.map((point, i) => (
            <motion.li
              key={i}
              className="section-text"
              variants={pointVariant}
            >
              <strong>{point.title}</strong>{" "}
              {point.text}
            </motion.li>
          ))}
        </motion.div>
      </motion.div>
    ))}
  </motion.div>
</motion.section>
) : (
  <AyurvedicApproach
    leftHeading={treatment.factorsHeading}
    leftItems={treatment.factorsPoints}
    rightHeading={treatment.approachHeading}
    rightDescription={treatment.approachDesc}
    rightItems={treatment.approachPoints}
  />
)}

       {/**AYURVEDIC TREATMENTS GRID */}
        <TreatmentCareGrid
        heading={treatment.treatmentCareHeading}
        grid={treatment.treatmentCare}
        />

        {/**WHY CHOOSE US SECTION */}
        <WhyChoose
        heading="Authentic Ayurvedic Treatments in Gandhidham, Kutch"
        />

        {/**STATS SECTION */}
        <Stats />

        {/**TREATMENTS GRID */}
        <TreatmentGrid 
        heading="Explore Our Other Ayurvedic Treatments in Gandhidham, Kutch"
        basePath="/treatments/gandhidham"
        />
        <div className="extra-margin"></div>

        {/**TESTIMONIALS SECTION */}
        <Testimonials />
        <div className="margin-div"></div>

        {/**CTA */}
        <Cta
        heading={treatment.ctaHeading}
        desc={treatment.ctaDesc}
        />

         </React.Fragment>
        </>
    )
}
export default TreatmentsDetailGandhidham;